import BaseEvent from './base_event';
import Breach from '../../objects/breach';
import * as effects from '../effects'

export default class BreachEvent extends BaseEvent {
    static canOccur(gameState, source) {    //it cannot occur by itself
        return !!source;
    }

    enter(gameState) {
        gameState.eventsResults.breach = true;

        let room = gameState.getRandomRoomWithoutHero();

        this.ui.showDialog({
            message: game.rnd.pick([
                "There’s a hull breach!",
                "Hull has been breached!",
                "Yarr! You have a hole in your bottom!"
            ]),
            options: [{
                text: "Send* Jenkins* to fix it!",
                condition: gameState.has('jenkins'),
                callback: () => {
                    //todo
                    this.end();
                }
            }, {
                text: "Use* Space Suit* and fix it by yourself",
                condition: gameState.has('spacesuit'),
                callback: () => {
                    let dice_roll = game.rnd.frac();
                    if (dice_roll < 0.5) {
                        this.ui.showDialog({ message: "You managed to patch the hole using suit as a vacuum seal. Unfortunately, it's no longer usable." }, () => {
                            gameState.items.removeItem(gameState.findFirstAvailable('spacesuit'));
                            this.ui.hideWindow(this.end)
                        })
                    } else {
                        this.ui.showDialog({ message: "You generously apply the superglue to a huge titanium plate and press it firmly to cover the breach. That should make it. Barely." }, () => {
                            this.ui.hideWindow(this.end)
                        })
                    }
                }
            }, {
                text: "Quick, put something in the hole before the room locks down!",
                callback: () => {
                    // todo show this in bottom log? it gets annoying after 2nd view
                    this.ui.showDialog({ message: "Hurry up, you have only 15 seconds from now" }, () => {
                        this.breachedRoom = room;
                        this.breachObj = new Breach(0, 0);
                        room.addBreach(this.breachObj);
                        this.timeLeft = 15 * 1000;
                        this.ui.hideWindow(() => {
                            effects.createExplosion(this.breachObj.x, this.breachObj.y);
                        })
                    })
                }

            }]
        })
    }

    update() {
        if (this.ui.dialogSprite.visible) return;
        //monkey patch
        if (!this.breachedRoom) return;

        if (!this.breachedRoom.breach) {
            //ok
            this.end();
            return;
        }
        this.timeLeft -= game.time.physicsElapsedMS;
        if (this.timeLeft <= 0 && this.gameState.getRoomWhereHeroIs() !== this.breachedRoom) {
            this.breachedRoom.disable();
            this.end();
        }
    }
}


// WEBPACK FOOTER //
// ./src/states/events/breach.js